import React from "react";
import { AnimationUtils } from "three";

import chrono from "chrono-node";
import * as luxon from "luxon";
import { DashboardUtils } from "../dashboard_utils";

interface InputFormProp {
	name?: string;
	initial_value: string;
	updateFunc: Function;
	char_limit?: number;
	placeholder: string;
	disabled?: boolean;
	info?: string;
	unsaved_changes?: boolean;
	note_text?: string | JSX.Element;
	additional_classnames?: string[];
	id?: string;
}

interface InputFormState {
	value: string;
}

export class TextInputForm extends React.Component<
	InputFormProp,
	InputFormState
> {
	constructor(props) {
		super(props);

		let value = props.initial_value ? props.initial_value : "";

		this.state = {
			value: value,
		};

		this.handleChange = this.handleChange.bind(this);
	}

	// TODO: Storing redundant state on both this form and its parent, fix??
	handleChange(event) {
		this.setState({ value: event.target.value });
		this.props.updateFunc(event.target.value);
	}

	render() {
		let classNames = "control";
		if (this.props.disabled) {
			classNames += " input-disabled";
		}

		let divClassNames = "field";
		if (this.props.additional_classnames) {
			divClassNames += ` ${this.props.additional_classnames.join(" ")}`;
		}

		return (
			<div className={divClassNames} id={this.props.id}>
				{this.props.name &&
					DashboardUtils.CreateHeaderAndInfoButton(
						this.props.name,
						this.props.info,
						undefined,
						undefined,
						this.props.unsaved_changes,
						undefined,
						this.props.disabled
					)}
				{this.props.note_text && (
					<div className="note">{this.props.note_text}</div>
				)}
				<div className={classNames}>
					<input
						className="input"
						placeholder={this.props.placeholder}
						disabled={Boolean(this.props.disabled)}
						type="text"
						value={this.state.value}
						onChange={this.handleChange}
						maxLength={this.props.char_limit}
					/>
				</div>
			</div>
		);
	}
}
